import Login from '../src/containers/Login'

export default Login
